import Device from 'constants/deviceSizes';

export default {
  content: {
    opacity: 0.5,
    display: 'flex',
    alignItems: 'center'
  },
  sidebarText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%'
  },
  detail: {
    paddingTop: 5,
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
  },
  activeContent: {
    opacity: 1,
    display: 'flex',
    alignItems: 'center'
  },
  sidebarItem: {
    marginRight: 20,
    height: 25,
    [Device.mobile]: {
      height: 16,
      margin: 0,
      padding: '2px 10px 2px 5px'
    }
  }
};
